import { Injectable, inject } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import type { Action } from '@ngrx/store';
import { switchMap } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { OfferContentGeneratorHttpService } from './offer-content-generator-http.service';
import { OfferContentGeneratorActions } from './offer-content-generator.store';
import type {
  OfferContentByChunkResponse,
  OfferContentByChunkResponseError,
} from './offer-content-generator.types';

@Injectable({
  providedIn: 'root',
})
export class OfferContentGeneratorEffects {
  private readonly actions$ = inject(Actions);
  private readonly offerContentGeneratorHttpService = inject(OfferContentGeneratorHttpService);

  public effects = createEffectFactory(OfferContentGeneratorActions, this.actions$);

  public fetchOne$ = this.effects(OfferContentGeneratorActions.fetch, ({ payload }) =>
    this.offerContentGeneratorHttpService.fetchOne$(payload),
  );

  public fetchOneByChunk$ = this.effects(
    OfferContentGeneratorActions.fetchEventStream,
    ({ payload }) =>
      this.offerContentGeneratorHttpService.fetchOneByChunk$(payload).pipe(
        switchMap((message: OfferContentByChunkResponse<string>) => {
          let actions: Array<Action<any>> = [
            OfferContentGeneratorActions.updateEventStream({
              payload: { content: message.message },
            }),
          ];

          const data: OfferContentByChunkResponseError = (_ => {
            try {
              return JSON.parse(message.message);
            } catch (err) {
              return undefined;
            }
          })();

          if (data?.error) {
            actions = [
              ...actions,
              OfferContentGeneratorActions.fetchEventFailed({ payload: data?.error[1] }),
            ];
          }

          if (message.type === 'load') {
            actions = [...actions, OfferContentGeneratorActions.fetchEventSuccess()];
          }

          return actions;
        }),

        takeUntil(this.actions$.pipe(ofType(OfferContentGeneratorActions.fetchEventStreamAbort))),
      ),
  );
}
